import { ePcConfigId } from './pc-config-id';

export interface iConsumeRecord {
  /**
   * 扣费金额
   * */
  change: number;
  /**
   * 机器类型;1:标配服，2:高配服; 3:体验服，4.高配
   */
  config_id: ePcConfigId;

  /**
   * 结束时间，为0表示进行中
   */
  end: number;

  id: number;

  nickname: string;
  /**
   * 订单号
   */
  order_no: string;

  /**
   * 计费单价，x云币/小时
   */

  price: number;

  /**
   * 开始时间
   */
  start: number;

  /**
   * 商户名称
   */
  store_name: string;

  uid: string;

  /**
   * 商户id
   */
  store_id: string;

  /**
   * 机器 mac地址
   */

  mac: string;

  /**
   * 地理位置(省-市)
   */
  locale: string;
  /**
   * 最后的延迟
   */
  last_ttl: number;
  /**
   * 意见反馈选择的文本内容
   */
  feedback_content: string;
  /**
   * 意见反馈-备注
   */
  feedback_remark: string;
}

export enum eOrderDuration {
  /**
   * 不限制
   */
  DEFAULT = 0,
  /**
   * 小于6分钟
   */
  LT_SIX_M = 1,
  /**
   * 大于等于6分钟
   */
  GTE_SIX_M = 2,
  /**
   * 进行中
   */
  CONDUCT = 3,
}
